import { createSlice } from '@reduxjs/toolkit';

import { fetchDashboardCounters } from '../actions/dashboard';

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    loading: false,
    error: null,
    counters: { calvesProducedCount: 0, calvesWeanedCount: 0 }
  },
  reducers: {
    setCounters(state, action) {
      state.counters = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchDashboardCounters.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardCounters.fulfilled, (state, action) => {
        state.loading = false;
        state.counters = action.payload;
      })
      .addCase(fetchDashboardCounters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default dashboardSlice.reducer;
